module.exports = __webpack_public_path__ + "static/media/2018 - 2019 theme logo.987e2174.jpg";